import "./navbartest.css"
import React from 'react'
import AITestContext from '../../../contexts/AITestContext'
import {Nav} from 'react-bootstrap';
import Navbar from 'react-bootstrap/Navbar';
import Offcanvas from 'react-bootstrap/Offcanvas';
import { ArrowBack } from "@mui/icons-material"
import 'bootstrap/dist/css/bootstrap.min.css'
import StatusContext from '../../../contexts/StatusContext'
import { AlertDialog } from '../alertdialog/AlertDialog'
import { ConfirmDialog } from '../alertdialog/ConfirmDialog'
import { DisplayMyCreatedTests } from '../aitest/DisplayMyCreatedTests'
import CircularProgress from '@mui/material/CircularProgress';
import { SaveChat } from '../savechat/SaveChat'
import {PushButton} from '../pushbutton/PushButton'
import { useState} from "react"
import Checkbox from '@mui/material/Checkbox';



export const NavBarCollegeTest = ({ title })=> {

  const[openSaveTestDialog, setSaveTestDialogBox] = useState(false)

 
  let {
    chatcollegetestName,
    chatcollegetestNames,
    setChatCollegeTestName,
    onSaveCollegeTest,
    handleDeleteCollegeTest,
    deleteTest, 
    displayCollegeChat,
  
    handleonArrowClick,
    setExpanded,
    expanded,
    openDialog, 
    setOpenDialogBox,
    dialogboxtext,
    openConfirmDialog, 
    setOpenConfirmDialogBox,
    isLoading,
    handleonClickNavBar,
    subtopics
 
} = React.useContext(AITestContext);


let {
  statusNavbar,
  changeLanguage,
  changeTestLanguage
} = React.useContext(StatusContext);


const alertYes = () => {
  closeDialogBox()
  deleteTest()
}

const alertCancel = () => {
  closeDialogBox()
}

const closeDialogBox = () => {
  setOpenDialogBox(false);
};

const alertSaveTestYes = () => {
  closeSaveTestDialogBox()
}

const alertSaveTestCancel = () => {
  closeSaveTestDialogBox()
}

const closeSaveTestDialogBox = () => {
  setSaveTestDialogBox(false);
};

const confirmYes = () => {
  closeConfirmDialogBox()
 
}

const closeConfirmDialogBox = () => {
  setOpenConfirmDialogBox(false);
};


const handleSelect = () => {
 
  setExpanded(!expanded)
}

const handleonChange = (e) => {
  setChatCollegeTestName(e.target.value )
  
}

  return (
    <Navbar  expanded={expanded} key={false} bg="" expand={false} className="mb-2 py-0" sticky=''>
   
        {
          isLoading &&
            <div className='wait-icon'>
                <CircularProgress style={{ color: 'white' }}/>
            </div>
        }
   
        <div> 
          <label className="navbarTitle"> {title}</label>
          <label className="navbarTemplateName"> {chatcollegetestName} </label>
        </div>
        
        <div style = {{marginRight: '10px'}}>
          <PushButton disabled = {isLoading} onClick={handleonClickNavBar} label =  {changeLanguage('aitest','savedtests')}/>
        </div>  
        
        <Navbar.Offcanvas
          id={`offcanvasNavbar-expand-false`}
          aria-labelledby={`offcanvasNavbarLabel-expand-false`}
          placement="end"
        >
          <Offcanvas.Header onClick={handleSelect}  >
            <Offcanvas.Title id={`offcanvasNavbarLabel-expand-false`}>
            <ArrowBack size='lg' className="styleIconWithBackground" onClick = {handleonArrowClick} />
            </Offcanvas.Title>
          </Offcanvas.Header>
          <Offcanvas.Body>
            <Nav className="justify-content-end flex-grow-1 pe-3">
            <label className="navbarTemplatesTitle">{changeTestLanguage('aitest','tests')}</label>

            <div className="navbarContainer">
              
                <ul className="navbarNames">
                    {
                        Array.isArray(chatcollegetestNames) &&
                            chatcollegetestNames.map((chat) => (
                              <React.Fragment key={chat.id}>
                                <DisplayMyCreatedTests chat={chat} deleteHandler={handleDeleteCollegeTest} clickHandler={displayCollegeChat} setExpand = {handleSelect} setTemplateName = {setChatCollegeTestName}/>
                                <hr className = 'aitestLineSeparator'></hr>
                              </React.Fragment>
                            ))
                    }
                </ul>
            </div>

           
       
        <br></br>

            <SaveChat label="Test name" text={chatcollegetestName} disabled={subtopics === null || subtopics.length === 0} onChange={handleonChange} onSave={onSaveCollegeTest}/>
           
            {
                (statusNavbar) &&
                    <div className='statusLabel'><label>{statusNavbar}</label></div>
              }
          <br></br>

        {/*
          <label style={{paddingRight:'5px', color:'maroon', fontSize:'18px', fontWeight:'500'}}> {changeLanguage('aitest', 'freevspaidtest')} </label>
          <p className='navbarFonts'>
                {changeLanguage('aitest', 'text42')} 
          </p>
        */}
          <label style={{paddingRight:'5px', color:'maroon', fontSize:'18px', fontWeight:'500'}}> {changeLanguage('aitest', 'howtocreatetest')} </label>
          <p className='navbarFonts'>
                {changeLanguage('aitest', 'text4')} 
          </p>


          <div className = 'flex-container' style={{marginTop: '-10px'}}>
              
                <Checkbox className='checkBoxTestName'
                  checked={true}
                  sx={{ '& .MuiSvgIcon-root': { fontSize: 24, color: 'maroon', border: 'none'}, 
                      
                  }} />
             
            <label style={{paddingRight:'5px'}}> {changeLanguage('aitest', 'activated')} </label>

          </div>

          <p className='navbarFonts'>
                {changeLanguage('aitest', 'text3')} 
                  <br></br>
            </p>

          <div>
           
           
            <p className='navbarFonts'>
              {changeLanguage('aitest', 'text22')} 
            </p>

            <p className='navbarFonts'>
              {changeLanguage('aitest', 'text41')} 
            </p>

          {/*
            <p className='navbarFonts'>
              {changeLanguage('aitest', 'text43')} 
            </p>
          */}
         
          
          </div>
        
            <AlertDialog alertYes={alertYes} alertCancel={alertCancel} openDialog = {openDialog} closeDialog = {closeDialogBox} prompt={dialogboxtext}/>
            <AlertDialog alertYes={alertSaveTestYes} alertCancel={alertSaveTestCancel} openDialog = {openSaveTestDialog} closeDialog = {closeSaveTestDialogBox} prompt={dialogboxtext}/>
            <ConfirmDialog alertYes={confirmYes} openDialog = {openConfirmDialog} closeDialog = {closeConfirmDialogBox} prompt={dialogboxtext}/>
          </Nav>
           
          </Offcanvas.Body>
        </Navbar.Offcanvas>
  
    </Navbar>
  );
}

export default NavBarCollegeTest;